<div class="header-menu-wrapper header-menu-wrapper-left h-100" id="kt_header_menu_wrapper">
    <!--begin::Header Menu-->
    <div id="kt_header_menu" class="header-menu header-menu-mobile header-menu-layout-default">
        <div class="aside-brand categ-logo d-flex flex-column align-items-center flex-column-auto py-5 px-5 py-lg-7">
            <!--begin::Logo-->
            <a [routerLink]="['/']">
               <!-- <img alt="Logo" src="assets/images/logo.png" class="max-h-30px" />-->
               <h3 class="logo-df">{{commonContent?.modules.champs}}</h3>
            </a>
            <!--end::Logo-->
        </div>
        <!--begin::Header top left Navbar-->
        <div class="d-flex align-items-baseline flex-wrap">
            <ul class="menu-nav top-nav-menu h-100">
                <li class="nav-item">
                    <a [routerLink]="['/setup']" [routerLinkActive]="['brown']" #rlaSetup="routerLinkActive"
                        [routerLinkActiveOptions]="{exact: false}"
                        class="nav-link btn btn-icon btn-clean h-100 btn-lg px-5">
                        <img
                            [src]="rlaSetup.isActive ? 'assets/images/icon/Setup.svg' : 'assets/images/icon/Setup-grey.svg'">
                        <h5>{{commonContent?.modules.setup}}</h5>
                    </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="['/rgm']" [routerLinkActive]="['blue']" #rlaRgm="routerLinkActive"
                        [routerLinkActiveOptions]="{exact: false}"
                        class="nav-link btn btn-icon btn-clean h-100 btn-lg px-5">
                        <img [src]="rlaRgm.isActive ? 'assets/images/icon/RGM.svg' : 'assets/images/icon/RGM-grey.svg'">
                        <h5>{{commonContent?.modules.rgm}}</h5>
                    </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="['/seg']" [routerLinkActive]="['purple-bg']" #rlaSeg="routerLinkActive"
                        [routerLinkActiveOptions]="{exact: false}"
                        class="nav-link btn btn-icon btn-clean h-100 btn-lg px-5">
                        <img [src]="rlaSeg.isActive ? 'assets/images/icon/SEG.svg' : 'assets/images/icon/SEG-grey.svg'">
                        <h5>{{commonContent?.modules.seg}}</h5>
                    </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="['/red']" [routerLinkActive]="['red-red']" #rlaRed="routerLinkActive"
                        [routerLinkActiveOptions]="{exact: false}"
                        class="nav-link btn btn-icon btn-clean h-100 btn-lg px-5">
                        <img [src]="rlaRed.isActive ? 'assets/images/icon/RED.svg' : 'assets/images/icon/RED-grey.svg'">
                        <h5>{{commonContent?.modules.cde}}</h5>
                    </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="['/rtm']" [routerLinkActive]="['purple']" #rlaRtm="routerLinkActive"
                        [routerLinkActiveOptions]="{exact: false}"
                        class="nav-link btn btn-icon btn-clean h-100 btn-lg px-5">
                        <img [src]="rlaRtm.isActive ? 'assets/images/icon/RTM.svg' : 'assets/images/icon/RTM-grey.svg'">
                        <h5>{{commonContent?.modules.rtm}}</h5>
                    </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="['/reports']" [routerLinkActive]="['light-green']" #rlaReports="routerLinkActive"
                        [routerLinkActiveOptions]="{exact: false}"
                        class="nav-link btn btn-icon btn-clean h-100 btn-lg px-5">
                        <img
                            [src]="rlaReports.isActive ? 'assets/images/icon/Reports.svg' : 'assets/images/icon/Reports-grey.svg'">
                        <h5>{{commonContent?.modules.report}}</h5>
                    </a>
                </li>
            </ul>
        </div>
        <!--end::Header top left Navbar-->
    </div>
    <!--end::Header Menu-->
</div>
